var React = require('react');

function UserTie (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M191.35 414.77L208 344l-32-56h96l-32 56 16.65 70.77L224 480zM224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M319.8 288.6L224 480l-95.8-191.4C56.9 292 0 350.3 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z","className":"fa-primary","key":2})]);
}

UserTie.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = UserTie;

UserTie.default = UserTie;
